import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import { ModifyDayAvailabilitiesPayloadInput } from './dto/day-availability';
import { FunctionCreationPayload, FunctionModifierPayload, functionProps } from './dto/function';
import { ModifyUserPayloadInput } from './dto/modify-user-payload-input';
import { UserFunctionPayload, userProps } from './dto/user';
import { UserAddedPayload } from './dto/user-added-payload';

export function ADD_USER(userAddedPayload: UserAddedPayload): GraphMutationBuilderPayload {
  return createMutation('addUser', {
    argument: 'userAddedPayload',
    props: `
      ${userProps.get('id')}
      ${userProps.get('userName')}
      ${userProps.get('firstName')}
      ${userProps.get('lastName')}
      ${userProps.get('phoneNumber')}
      ${userProps.get('isDisabled')}
      ${userProps.get('culture')}
      ${userProps.get('trigram')}
      ${userProps.get('picture')}
      ${userProps.get('pictureDocumentId')}
    `,
    value: userAddedPayload,
  });
}

export function UPDATE_CURRENT_USER(user: ModifyUserPayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateCurrentUser', {
    argument: 'user',
    props: `
      ${userProps.get('firstName')}
      ${userProps.get('lastName')}
      ${userProps.get('phoneNumber')}
      ${userProps.get('picture')}
      ${userProps.get('pictureDocumentId')}
    `,
    type: 'ModifyUserPayloadInput!',
    value: user,
  });
}

export function UPDATE_USER(payload: ModifyUserPayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateUser', {
    props: `
      ${userProps.get('id')}
      ${userProps.get('userName')}
      ${userProps.get('firstName')}
      ${userProps.get('lastName')}
      ${userProps.get('phoneNumber')}
      ${userProps.get('isDisabled')}
      ${userProps.get('culture')}
      ${userProps.get('trigram')}
      ${userProps.get('picture')}
      ${userProps.get('pictureDocumentId')}
      ${userProps.get('functions')} {
      ${functionProps.get('id')}
      ${functionProps.get('name')}
      }
    `,
    type: 'ModifyUserPayloadInput!',
    value: payload,
  });
}

export function ADD_FUNCTION(functionAddedPayload: FunctionCreationPayload): GraphMutationBuilderPayload {
  return createMutation('addFunction', {
    value: functionAddedPayload,
  });
}

export function UPDATE_FUNCTION(
  functionModifierPayload: Partial<FunctionModifierPayload>
): GraphMutationBuilderPayload {
  return createMutation('updateFunction', {
    type: 'ModifyFunctionPayloadInput!',
    value: functionModifierPayload,
  });
}

export function ADD_FUNCTION_TO_USER(payload: UserFunctionPayload): GraphMutationBuilderPayload {
  return createMutation('addFunctionToUser', {
    props: `
      userId
    `,
    type: 'UserFunctionPayloadInput!',
    value: payload,
  });
}

export function REMOVE_FUNCTION_FROM_USER(payload: UserFunctionPayload): GraphMutationBuilderPayload {
  return createMutation('removeFunctionFromUser', {
    props: '',
    type: 'UserFunctionPayloadInput!',
    value: payload,
  });
}

export function UPDATE_DAY_AVAILABILITY(
  payload: Partial<ModifyDayAvailabilitiesPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateDayAvailability', {
    type: 'ModifyDayAvailabilitiesPayloadInput!',
    value: payload,
  });
}
